import { Card, CardBody, Col } from "reactstrap";
import { RecentStatisticsTitle } from "../../../../../Constants/Constants";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { LI, UL } from "../../../../../AbstractElements";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";
import ReactApexChart from "react-apexcharts";
import { OrderOverView } from "../../../../../Data/General/Dashboard/Default";

const RecentStatistics = () => {
  return (
    <Col xl="5" md="6">
      <Card>
        <DashboardCommonHeader title={RecentStatisticsTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="pb-0">
          <div className="recent-statistics">
            <UL className="simple-list flex-row">
              <LI>
                <div className="arrow-up">
                  <SvgIcon iconId="Arrow-Up" />
                </div>
                <span>$4.280</span>
              </LI>
              <LI>
                <div className="arrow-down">
                  <SvgIcon iconId="Arrow-Down" />
                </div>
                <span>$1.530</span>
              </LI>
            </UL>
          </div>
          <div id="orderoverview">
            <ReactApexChart type="line" options={OrderOverView} series={OrderOverView.series} height={285} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RecentStatistics;
